import type { TourStep } from '../types';

export const layoutHelpSteps: TourStep[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Справка генератора макетов',
    content: 'Здесь ответы на вопросы по всем экранам генератора, курс для новых операторов и проверка себя.',
  },
  {
    target: '[data-tour="help-search"]',
    title: 'Поиск ответа',
    content: 'Пишите словами с экрана: название кнопки, статуса или сообщения — «пакетный», «поле 15 мм», «ждёт сверки». Совпадения подсвечиваются.',
  },
  {
    target: '[data-tour="help-sections"]',
    title: 'Разделы',
    content: 'Статьи по экранам: список заданий, новое задание, студия, паспорт серии, редактор, дублирование, ошибки, частые вопросы и словарь.',
  },
  {
    target: '[data-tour="help-course"]',
    title: 'Курс оператора',
    content: 'Десять уроков по порядку работы: что прочитать, тур по экрану и практика без расходов. Отмечайте пройденное — прогресс сохранится.',
  },
  {
    target: '[data-tour="help-quiz"]',
    title: 'Проверь себя',
    content: 'Вопросы по типовым ситуациям: ответ сразу показывает, верно ли, и ссылку на статью.',
  },
  {
    target: 'body',
    placement: 'center',
    title: 'Справка на каждом экране',
    content: 'На экранах генератора кнопка «Помощь» откроет справку по этому экрану сбоку — без ухода со страницы.',
  },
];
